import React, { type HTMLAttributes } from 'react';
import styled from 'styled-components';
import { SvgSprite } from 'modules/svgSprite';
import { Body } from 'components/generic/typography';
import { Spacing8, Spacing20, Spacing12 } from 'autogen/design-tokens/tokens';
import { breakpoint, sizes } from 'variables';
import type { FooterUspViewModel } from 'autogen/swagger/all';

const Item = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;

    ${breakpoint.up(sizes.md)} {
        flex-direction: row;
    }
`;

const StyledSvgSprite = styled(SvgSprite)`
    width: 100%;
    height: 100%;
    max-width: 30px;
    max-height: 30px;
    margin: 0 0 ${Spacing12};

    ${breakpoint.up(sizes.md)} {
        margin: 0 ${Spacing20} 0 0;
    }
`;

const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

const StyledBody = styled(Body)`
    margin-bottom: ${Spacing8};
`;

interface IUSPItem extends HTMLAttributes<HTMLDivElement> {
    usp: FooterUspViewModel;
}

export default function USPItem({ usp, ...restProps }: IUSPItem) {
    const { title, sprite, subTitle } = usp;

    return (
        <Item {...restProps}>
            {!!sprite && <StyledSvgSprite sprite={sprite} aria-hidden />}
            <TextContainer>
                <StyledBody forwardedAs="span" size="M" strong>
                    {title}
                </StyledBody>
                <Body as="span" size="M">
                    {subTitle}
                </Body>
            </TextContainer>
        </Item>
    );
}
